import { submitForm, deleteFile } from "./s3post";

function _parse_query_string(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
            query_string[key] = decodeURIComponent(value);
            // If second entry with this name
        } else if (typeof query_string[key] === "string") {
            var arr = [query_string[key], decodeURIComponent(value)];
            query_string[key] = arr;
            // If third or later entry with this name
        } else {
            query_string[key].push(decodeURIComponent(value));
        }
    }
    return query_string;
}

const getStxFile = async () => {

    const params = _parse_query_string(window.location.search.substring(1));

    let stx;
    if (params.stx != null) {
        stx = await fetch(params.stx);
        stx = await stx.text();
        return stx;
    }

}

const awsPostData = async (file, fileName, location) => {

    const params = _parse_query_string(window.location.search.substring(1));

    let response = "NO RESPONSE";

    if (params.stx !== undefined && params.awsId !== undefined && params.awsKey !== undefined) {
        const bucket = location.split(".")[0].split("//")[1];
        const stxList = location.split("/");
        let fileLocation = location.split(bucket)[1].split("/");
        fileLocation.shift();
        fileLocation = fileLocation.join("/") + fileName;

        response = await submitForm(params.awsId, params.awsKey, bucket, fileLocation, file, "https://" + stxList[2] + "/");
    }
    return response;
}

const awsPost = async (file, disableCache) => {

    const params = _parse_query_string(window.location.search.substring(1));

    if (params.stx !== undefined && params.awsId !== undefined && params.awsKey !== undefined) {

        const bucket = params.stx.split(".")[0].split("//")[1];
        const stxList = params.stx.split("/");
        let fileName = params.stx.split(bucket)[1].split("/");
        fileName.shift();
        fileName = fileName.join("/")

        console.log("bucket: " + bucket + "\nfileName: " + fileName);

        fileName = fileName.replace(/\+/g, " ")

        console.log(fileName)

        return submitForm(params.awsId, params.awsKey, bucket, fileName, file, "https://" + stxList[2] + "/", disableCache);
    }

}

const awsDeleteData = async (fileName) => {
    // this doesn't work, I'll figure it out later
    const params = _parse_query_string(window.location.search.substring(1));

    if (params.stx !== undefined && params.awsId !== undefined && params.awsKey !== undefined) {

        const bucket = params.stx.split(".")[0].split("//")[1];
        const stxList = params.stx.split("/");

        deleteFile(params.awsId, params.awsKey, bucket, fileName, "https://" + stxList[2] + "/");
    }
}


export { getStxFile, awsPost, awsPostData, awsDeleteData };